<template>
    <div class="modal fade show checkin-details-modal" aria-labelledby="checkinDetailsModalTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                    <h1 class="mb-0">Check-In Details</h1>
                    <button @click="onClickClose" type="button" class="btn-close" aria-label="Close"></button>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                    <div class="col-11 py-1 mx-auto">
                        <div class="row">
                            <div class="col-md-3 mb-2">
                                <label class="form-label">Date of Check-in</label>
                                <input v-model="checkIn" type="date" class="form-control"/>
                            </div>
                            <div class="col-md-3 mb-2">
                                <label class="form-label">Date of Check-out</label>
                                <input v-model="checkOut" type="date" class="form-control"/>
                            </div>
                        </div>

                        <RoomAvailabilityPicker
                            v-if="checkIn"
                            v-model="selectedRooms"
                            :check-in="checkIn"
                            :check-out="checkOut"
                            :nights="nights"
                            :own-room-ids="ownRoomIds"
                            pagination-state-name="secondPaginationData"
                            :offset="12"
                            :show-room-type="false"
                        />

                        <div class="d-flex justify-content-end mt-2">
                            <button type="button" class="btn btn-outline-secondary" @click="onClickClose">Close Check-In Details</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import RoomAvailabilityPicker from '@/components/molecule/company/hotel/RoomAvailabilityPicker.vue';
import { computed } from 'vue';

const props = defineProps({
    reservation: {
        type: Object,
        required: true,
    },
    modelValue: {
        type: Array,
        required: true,
    },
    ownRoomIds: {
        type: Array,
        default: () => [],
    },
    nights: {
        type: Number,
        required: true,
    },
});

const emit = defineEmits(['update:modelValue', 'onClose']);

const checkIn = computed({
    get: () => props.reservation.check_in,
    set: (value) => { props.reservation.check_in = value; },
});

const checkOut = computed({
    get: () => props.reservation.check_out,
    set: (value) => { props.reservation.check_out = value; },
});

const selectedRooms = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
});

const onClickClose = () => {
    emit('onClose');
};
</script>

<style scoped>
.checkin-details-modal .modal-dialog {
    max-width: 1140px;
}
</style>
